const av = module.exports = require('./constants')
const Color = require('./src_em/color')
for(const k in Color) av[k] = Color[k]

av.Matrix = require('./src_em/matrix')
av.Decoder = require('./src_em/decoder')
av.H264 = require('./src_em/H264')
av.BMFF = require('./src_em/BMFF')
av.MP4 = require('./src_em/MP4')
av.SPS = require('./src_em/SPS')

const Decoder = av.Decoder

av.wasm = null
av.log_level = av.LOG_LEVEL.ERROR

av.init = async function() {
  if(!av.wasm) {
    av.wasm = await require('./avff.js')()
    av.logLevel(av.log_level)
  }
} // init

av.logLevel = function(log_level) {
  av.log_level = log_level
  if(av.wasm) av.wasm.ccall('log_level', null, ['number'], [log_level])
}

av.createJPEGDecoder = async ()=>av.createDecoder('JPEG', 'YUVJ420P')
av.createJPEG2000Decoder = async ()=>av.createDecoder('JPEG2000', 'RGB24')
av.createH264Decoder = async ()=>av.createDecoder('H264', 'YUV420P')
av.createDecoder = async function(...args) {
  await av.init()
  const decoder = new Decoder(av.wasm)
  return decoder.init(...args)
} // createDecoder
